<script lang="ts">
  import type {Writable} from 'svelte/store';
  import {writable} from 'svelte/store';
  import {setContext, getContext} from 'svelte';
  import {generatePalette, formatStyleString} from 'Catalyst/utility/theme';
  import type {CssColor, BrandColor, Background} from 'Catalyst/utility/theme';
  import type {ThemeContextProps} from '.';

  export let brandColor: ThemeContextProps['brandColor'] = undefined;
  export let brandColors: ThemeContextProps['brandColors'] = brandColor
    ? [
        {
          key: 'brand-color',
          value: brandColor,
        },
      ]
    : [];
  export let backgroundColor: ThemeContextProps['backgroundColor'] = undefined;
  export let overrideParentTheme: boolean = false;

  const brandColorsStore = writable<BrandColor[]>(brandColors);
  const backgroundColorStore = writable<Background>(backgroundColor);
  const theme = writable<Record<string, CssColor>>({});

  let palette;

  const parentTheme = getContext<Writable<Record<string, CssColor>>>('theme');

  $: if ((!parentTheme || overrideParentTheme) && brandColors.length > 0) {
    setContext('brandColors', brandColorsStore);
    setContext('backgroundColor', backgroundColorStore);

    brandColorsStore.set(brandColors);
    backgroundColorStore.set(backgroundColor);

    palette =
      $brandColorsStore?.length > 0 &&
      generatePalette($brandColorsStore, $backgroundColorStore);
    theme.set(palette);

    setContext('theme', theme);
  }
</script>

{#if palette}
  <div style={formatStyleString(palette)}>
    <slot />
  </div>
{:else}
  <slot />
{/if}
